<div id="content">
  <div class="grid-item">
    <button class="button-add" (click)="add()">Hinzufügen</button>
  </div>
  <!-- <div class="grid-item right">
    <button class="button-export" (click)="export()">Export</button>
  </div> -->

  <div class="grid-item-full">
    @if (loading) {
      <div>
        <mat-spinner class="center"></mat-spinner>
      </div>
    } @else {
      <mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="Name">
          <mat-header-cell *matHeaderCellDef> Kursname </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="edit(element)">
            {{ element.name }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Enroll">
          <mat-header-cell *matHeaderCellDef> Teilnehmer </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="showStudents(element)">
            {{ element | enroll }}
          </mat-cell>
        </ng-container>
        
        <ng-container matColumnDef="Diffname">
          <mat-header-cell *matHeaderCellDef> Alternativname </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="edit(element)">
            {{ element.diffname }}
          </mat-cell>
        </ng-container>       

        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef> Beschreibung </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="edit(element)">
            {{ element.description }}
          </mat-cell>
        </ng-container>
        
        <ng-container matColumnDef="Level">
          <mat-header-cell *matHeaderCellDef> Level </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="edit(element)">
            {{ element.level }}
          </mat-cell>
        </ng-container>  
        
        <ng-container matColumnDef="Age">
          <mat-header-cell *matHeaderCellDef> Alter </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="edit(element)">
            {{ formatAge(element.age_begin, element.age_end) }}
          </mat-cell>
        </ng-container>
       
        <ng-container matColumnDef="Link">
          <mat-header-cell *matHeaderCellDef> Link </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="edit(element)">
            {{ element.link }}
          </mat-cell>
        </ng-container>        
        
        <ng-container matColumnDef="Color">
          <mat-header-cell *matHeaderCellDef> Farbe </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div
              class="color-circle"
              [style.background]="formatColor(element.color)"
              title="{{ formatColor(element.color) }}"
            ></div>
          </mat-cell>
        </ng-container>   

        <ng-container matColumnDef="Actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element" class="actions">
            <mat-icon (click)="delete(element)">delete</mat-icon>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="['Name', 'Enroll', 'Diffname', 'Description', 'Level', 'Age', 'Link', 'Color', 'Actions']">
        </mat-header-row>

        <mat-row
          *matRowDef="let row; columns: ['Name', 'Enroll', 'Diffname', 'Description', 'Level', 'Age', 'Link', 'Color', 'Actions']">
        </mat-row>
      </mat-table>
    }
  </div>
  <div class="grid-item">
    <input
      matInput
      id="courseFilter"
      (keyup)="applyFilter($event)"
      placeholder="Filtern" />
  </div>
  <div class="grid-item"></div>

<li-course-enroll
  [course]="viewingCourse"
  [students]="viewingCourseStudents"
  [readOnly]="true"
  (closing)="viewingCourse = undefined">
</li-course-enroll>

<li-course-edit
  [course]="selectedCourse"
  (closing)="commit()">
</li-course-edit>


